
import styled from "styled-components";

import { Input } from "../../../../components/Form/shared-style";

export const Column = styled.div``;

export const DeleteLabel = styled.div`
    display: inline-block;
    width: 11px;
    text-align: center;
    line-height: 11px;
    margin-left: 8px;
    cursor: pointer;
    color: ${p => p.theme.c.snow};
    font-weight: 300;
    transform: scale(1.4) translate(2px, 0);
`; // TODO export

export const StyledInput = styled.input`
    ${Input}
`; // TODO export